/**
 * Shared formatters for consistent display across the CRM.
 */

export function formatCurrency(amount) {
  if (amount == null || isNaN(Number(amount))) return 'PKR 0';
  return new Intl.NumberFormat('en-PK', {
    style: 'currency',
    currency: 'PKR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(Number(amount));
}

const STATUS_COLORS = {
  'New':               'bg-blue-100 text-blue-700',
  'Contacted':         'bg-amber-100 text-amber-700',
  'In Progress':      'bg-purple-100 text-purple-700',
  'Follow Up':        'bg-orange-100 text-orange-700',
  'Negotiating':      'bg-indigo-100 text-indigo-700',
  'Won':              'bg-emerald-100 text-emerald-700',
  'Lost':             'bg-red-100 text-red-700',
  'Queued Unassigned':'bg-gray-100 text-gray-600',
  'Archived':         'bg-slate-100 text-slate-600',
};

export function getStatusColor(status) {
  if (!status) return 'bg-gray-100 text-gray-600';
  const normalized = status.charAt(0).toUpperCase() 
                   + status.slice(1).toLowerCase();
  return STATUS_COLORS[normalized] 
      || STATUS_COLORS[status] 
      || 'bg-gray-100 text-gray-600';
}

export function formatStatusLabel(status) {
  if (!status) return '';
  return status.charAt(0).toUpperCase() + status.slice(1).replace('_', ' ');
}

export function formatPhoneDisplay(phone) {
  if (!phone) return '-';
  
  // Remove all non-numeric characters
  const digits = String(phone).replace(/\D/g, '');
  
  // Pakistani numbers: 92XXXXXXXXXX → +92 XXX XXXXXXX
  if (digits.startsWith('92') && digits.length === 12) {
    return `+92 ${digits.slice(2, 5)} ${digits.slice(5)}`;
  }
  
  // Pakistani numbers starting with 0: 0XXXXXXXXXX → +92 XXX XXXXXXX
  if (digits.startsWith('0') && digits.length === 11) {
    return `+92 ${digits.slice(1, 4)} ${digits.slice(4)}`;
  }
  
  // US/International: 1XXXXXXXXXX → +1 (XXX) XXX-XXXX
  if (digits.startsWith('1') && digits.length === 11) {
    return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }
  
  // Other international: add + prefix if long enough
  if (digits.length > 10) {
    return `+${digits}`;
  }
  
  // Fallback: return cleaned digits
  return digits || phone;
}

export function getSourceBadgeColor(source) {
  const s = String(source || '').toLowerCase();
  if (s.includes('meta') || s.includes('facebook')) 
    return { bg: '#ede9fe', text: '#7c3aed' };
  if (s.includes('whatsapp')) 
    return { bg: '#dcfce7', text: '#16a34a' };
  if (s.includes('referral')) 
    return { bg: '#fef3c7', text: '#d97706' };
  if (s.includes('direct')) 
    return { bg: '#dbeafe', text: '#2563eb' };
  if (s.includes('eighteen'))
    return { bg: '#fce7f3', text: '#db2777' }; // Engaging pinkish color
  // default
  return { bg: '#f3f4f6', text: '#6b7280' };
}

export function formatLocation(city, country) {
  if (!city && !country) return '-';
  const parts = [city, country]
    .filter(Boolean)
    .map(p => p.charAt(0).toUpperCase() + p.slice(1).toLowerCase());
  return parts.join(', ');
}
